/* @flow */
// typecheck: ignore file
import React from 'react';
import gql from 'graphql-tag';
import classesDefaultsFragment from 'groups/fragments/classesDefaultsFragment.gql';
import Group from 'entities/Group';
import Heading from 'components/Heading.jsx';
import Text from 'components/Text.jsx';
import InviteButton from 'users/components/InviteButton.jsx';
import SchoolStatistics from 'admin/components/SchoolStatistics.jsx';
import { graphql } from 'react-apollo';

import './styles/AdminSchoolHeader.scss';

type Props = {
  schoolId: number, // eslint-disable-line
  organization?: {
    id: number,
    name: string,
    paid: boolean,
    class: ?Object,
  }
};

function AdminSchoolHeader(props: Props) {
  const { organization, schoolId } = props;
  const groupEntity = organization && organization.class && Group.fromJSON(organization.class);

  return (
    <div className="AdminSchoolHeader">
      <div>
        <Heading level="1">
          <Text size="xlarge" weight="semibold">
            {organization ? organization.name : <span>&nbsp;</span>}
          </Text>
        </Heading>
        <div className="AdminSchoolHeader-stats">
          <SchoolStatistics organizationId={schoolId} />
        </div>
      </div>
      <div className="AdminSchoolHeader-action">
        {organization && organization.paid && groupEntity &&
          <InviteButton group={groupEntity} forceType="button" />
        }
      </div>
    </div>
  );
}

const withOrganizationAndClass = graphql(gql`
  ${classesDefaultsFragment}

  query($organizationId: Int) {
    organizations(ids: [$organizationId]) {
      id
      name
      paid
      class {
        ...classesDefaults
      }
    }
  }
  `,
  {
    options: ({ schoolId }) => ({
      variables: { organizationId: [schoolId] },
    }),
    props: ({ data }) => ({
      organization: data.organizations ? data.organizations[0] : null,
    }),
  }
);

export { AdminSchoolHeader };
export default withOrganizationAndClass(AdminSchoolHeader);



// WEBPACK FOOTER //
// ./src/admin/components/AdminSchoolHeader.jsx